import React, { useState } from "react";
import { bool, oneOf, string } from "prop-types";
import { Box, Link, Typography } from "@mui/material";
import OndemandVideoRoundedIcon from "@mui/icons-material/OndemandVideoRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import { formateDate } from "../../../utils/date";
import LaunchIcon from "@mui/icons-material/Launch";
import VideoDialog from "../../VideoDialog";
import EventIcon from "@mui/icons-material/Event";
import googleAnalytics from "shared/analytics";
import NewChip from "../../NewChip";

const ComingSoonCardSection = ({
  type = "report",
  title,
  date,
  registrationUrl = null,
  videoId = null,
  description = "",
  isNew = false,
}) => {
  let typeName = "Report";
  if (type !== "report") {
    typeName = type === "event" ? "Exclusive Event" : "Exclusive Webinar";
  }
  const showDate = !(type === "webinar" && videoId);
  const [modalOpen, setOpenModal] = useState(false);
  const toggleModal = () => {
    googleAnalytics.trackVideoThumbnailClick(title);
    setOpenModal(!modalOpen);
  };

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        gap: theme.spacing(1.5),
        position: "relative",
      })}
    >
      <Box
        sx={(theme) => ({
          color: theme.palette.primary.main,
          fontSize: 40,
          [theme.breakpoints.up("sm")]: {
            fontSize: 45,
          },
        })}
      >
        {type === "report" && <DescriptionRoundedIcon fontSize="inherit" />}
        {type === "webinar" && <OndemandVideoRoundedIcon fontSize="inherit" />}
        {type === "event" && <EventIcon fontSize="inherit" />}
      </Box>
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: 0,
          [theme.breakpoints.up("sm")]: {
            gap: "2px",
          },
        })}
      >
        <Typography variant="caption">{typeName}</Typography>
        <Typography
          component="h2"
          variant="h4"
          sx={{ marginBottom: "3px", fontWeight: "bold", display: "flex", gap: "5px" }}
        >
          {title}
          {isNew && <NewChip count={undefined} size="small" />}
        </Typography>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {date && showDate && (
            <Box sx={{ display: "flex", gap: "5px" }}>
              <Typography variant="body2">Date:</Typography>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {formateDate(date, { format: "m d, Y" })}
              </Typography>
            </Box>
          )}
          {registrationUrl && date && showDate && <Typography>|</Typography>}
          {registrationUrl && (
            <Link
              target="_blank"
              variant="body2"
              href={registrationUrl}
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
                "& svg": {
                  transform: "translateY(2px)",
                },
              }}
              onClick={() =>
                googleAnalytics.trackExternalLinkClick({
                  location: "Coming Soon Card",
                  url: registrationUrl,
                })
              }
            >
              {type === "webinar" && "Register now for webinar"}
              {type === "event" && "Click here for more information"}
              <LaunchIcon fontSize="inherit" />
            </Link>
          )}
          {videoId && (
            <>
              <Link
                component="button"
                variant="body2"
                underline="hover"
                onClick={() => toggleModal()}
              >
                View webinar recording
              </Link>
              <VideoDialog
                modalOpen={modalOpen}
                toggleModal={toggleModal}
                video={{ id: videoId, title, description }}
              />
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
ComingSoonCardSection.propTypes = {
  type: oneOf(["report", "webinar", "event"]),
  title: string.isRequired,
  date: string,
  registrationUrl: string,
  videoId: string,
  description: string,
  isNew: bool,
};

export default ComingSoonCardSection;
